import React from 'react';
import Loadable from 'react-loadable';


const Footer = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default Footer;
